import { Deal, DealType, DealStatus } from '../../types';

export let mockDeals: Deal[] = [
  {
    id: 'deal-1',
    name: 'TechCorp Acquisition',
    description: 'Strategic acquisition of TechCorp to expand our technology portfolio',
    deal_type: DealType.Acquisition,
    status: DealStatus.DueDiligence,
    estimatedValue: 150000000,
    currency: 'USD',
    company: 'TechCorp Solutions Inc.',
    industry: 'Technology',
    source: 'Internal',
    region: 'North America',
    created_by: '1',
    created_at: '2024-06-01T10:00:00Z',
    updated_at: '2024-06-28T15:30:00Z',
    expectedCloseDate: '2024-09-15T00:00:00Z',
    actual_close_date: null,
    tags: ['technology', 'acquisition', 'strategic'],
    creator_name: 'John Doe',
    investment_memos: [],
    project_count: 1,
  },
  {
    id: 'deal-2',
    name: 'GreenEnergy Investment',
    description: 'Series B investment in renewable energy startup',
    deal_type: DealType.Investment,
    status: DealStatus.Negotiation,
    estimatedValue: 25000000,
    currency: 'USD',
    company: 'GreenEnergy Solutions',
    industry: 'Clean Energy',
    source: 'Referral',
    region: 'Europe',
    created_by: '2',
    created_at: '2024-04-15T09:00:00Z',
    updated_at: '2024-06-20T14:20:00Z',
    expectedCloseDate: '2024-08-30T00:00:00Z',
    actual_close_date: null,
    tags: ['investment', 'clean-energy', 'series-b'],
    creator_name: 'Jane Smith',
    investment_memos: [],
    project_count: 0,
  },
  {
    id: 'deal-3',
    name: 'RetailChain Merger',
    description: 'Merger with regional retail chain to expand market presence',
    deal_type: DealType.Merger,
    status: DealStatus.Approved,
    estimatedValue: 75000000,
    currency: 'USD',
    company: 'Regional Retail Holdings',
    industry: 'Retail',
    source: 'Bank',
    region: 'North America',
    created_by: '3',
    created_at: '2024-03-10T11:30:00Z',
    updated_at: '2024-06-25T16:45:00Z',
    expectedCloseDate: '2024-07-31T00:00:00Z',
    actual_close_date: null,
    tags: ['merger', 'retail', 'expansion'],
    creator_name: 'Peter Jones',
    investment_memos: [],
    project_count: 1,
  },
  {
    id: 'deal-4',
    name: 'PropTech Venture',
    description: 'Joint venture with PropTech company for real estate innovation',
    deal_type: DealType.JointVenture,
    status: DealStatus.Pipeline,
    estimatedValue: 50000000,
    currency: 'USD',
    company: 'PropTech Innovations',
    industry: 'Real Estate Technology',
    source: 'Conference',
    region: 'North America',
    created_by: '4',
    created_at: '2024-05-20T14:00:00Z',
    updated_at: '2024-06-15T10:30:00Z',
    expectedCloseDate: '2024-10-15T00:00:00Z',
    actual_close_date: null,
    tags: ['joint-venture', 'proptech', 'innovation'],
    creator_name: 'Mary Williams',
    investment_memos: [],
    project_count: 0,
  },
  {
    id: 'deal-5',
    name: 'Manufacturing Divestiture',
    description: 'Divestiture of non-core manufacturing assets',
    deal_type: DealType.Divestiture,
    status: DealStatus.Closed,
    estimatedValue: 120000000,
    currency: 'USD',
    company: 'Industrial Manufacturing Corp',
    industry: 'Manufacturing',
    source: 'Internal',
    region: 'North America',
    created_by: '1',
    created_at: '2024-01-15T08:00:00Z',
    updated_at: '2024-05-30T17:00:00Z',
    expectedCloseDate: '2024-05-30T00:00:00Z',
    actual_close_date: '2024-05-30T17:00:00Z',
    tags: ['divestiture', 'manufacturing', 'closed'],
    creator_name: 'John Doe',
    investment_memos: [],
    project_count: 1,
  },
];

export const getDealById = (dealId: string): Deal | undefined => {
  return mockDeals.find(deal => deal.id === dealId);
};

export const getDealsByStatus = (status: DealStatus): Deal[] => {
  return mockDeals.filter(deal => deal.status === status);
};

export const getActiveDealsByUser = (userId: string): Deal[] => {
  return mockDeals.filter(deal =>
    deal.created_by === userId &&
    deal.status !== DealStatus.Closed &&
    deal.status !== DealStatus.Rejected
  );
};

export const deleteDealById = (dealId: string): void => {
  mockDeals = mockDeals.filter(deal => deal.id !== dealId);
};
